export default {
  transactionHistoryOffice (state) {
    return state.transactionHistoryOffice
  }
}
